import React, { useState, useEffect } from "react";
import "../Styles/Cmrf.css";
import { IoPlayCircle } from "react-icons/io5";
import {
  FaUsers,
  FaMoneyBillWave,
  FaFileAlt,
  FaCheckCircle,
  FaMapMarkerAlt,
  FaBuilding,
} from "react-icons/fa";

import cmrf1 from "../essets/cmrf1.png";
import cmrf2 from "../essets/cmrf2.png";
import cmrf3 from "../essets/cmrf3.png";
import cmrf4 from "../essets/cmrf4.png";
import cmrf5 from "../essets/cmrf5.png";
import cmrf6 from "../essets/cmrf6.png";
import cmrf7 from "../essets/cmrf7.png";
import cmrf8 from "../essets/cmrf8.png";

import video1 from "../essets/cmrfv1.mp4";
import video2 from "../essets/cmrfv2.mp4";
import video3 from "../essets/cmrfv3.mp4";
import video4 from "../essets/cmrfv4.mp4";
import video5 from "../essets/cmrfv5.mp4";
import video6 from "../essets/cmrfv6.mp4";
import video7 from "../essets/cmrfv7.mp4";
import video8 from "../essets/cmrfv8.mp4";

const Cmrf = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedMandal, setSelectedMandal] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [sortOrder, setSortOrder] = useState("latest");
  const [currentPage, setCurrentPage] = useState(1);

  const CARDS_PER_PAGE = 2;

  const mandalVillages = {
    Kandukur: [
      "Anandapuram", "Anantha Sagaram", "Donda Padu", "G.Meka Padu",
      "Jillelamudi", "Kancharagunta", "Kondamudusu Palem", "kandukur",
      "Kovur", "Machavaram", "Madanagopalapuram", "Mahadevapuram",
      "Mopadu", "Muppalakesaram", "Ogur", "Palukur", "Palur",
      "Pandalapadu", "Vikkiralapeta",
    ],
    Lingasamudram: [
      "Anneboinapalle", "Cheemalapenta", "Chinapavani", "Gangapalem",
      "Jagamreddi Khandrika", "Lingasamudram", "Malakondarayunipalem",
      "Mogilicherla", "Mukteswaram", "Mutyalapadu", "Narasimhapuram",
      "Pentrala", "Racheruvurajupalem", "Rallapadu", "Thimmareddypalem",
      "Thunugunta", "Thurpu Rajupalem", "Veeraraghavunikota",
      "Vengalapuram", "Viswanadhapuram",
    ],
    Gudluru: [
      "Ammavaripalem", "Basireddypalem", "Chevuru", "Chinalatrapi",
      "Dappalampadu", "Darakanipadu", "Gudluru", "Gundlapalem",
      "Kothapeta", "Mocherla", "Nayudupalem", "Parakondapadu Agraharam",
      "Parakondapadu", "Potluru", "Puretipalle", "Ravur",
      "Swarnajipuram", "Venkampeta",
    ],
    Ulavapadu: [
      "Atmakur", "Baddepudi", "Bheemavaram", "Chagallu", "Chaki Cherla",
      "K. Rajupalem", "Karedu", "Kollurupadu", "Krishnapuram",
      "Manneti Kota", "Ramayapatnam", "Veerepalle",
    ],
    Voletivaripalem: [
      "Ayyavaripalle", "Chundi", "East Polineni Palem", "Kakutur",
      "Kalavalla", "Kondareddipalem", "Kondasamudram", "Naladalapur",
      "Nawabpalem", "Nekunam Puram K.Kandrika", "Nekunampuram @ Pokur",
      "Nukavaram", "Polineni Cheruvu", "Ramachandrapuram",
      "Ramalingapuram", "Sakhavaram", "Sameerapalem", "Singamnenipalle",
      "Veeranna Palem", "Voletivaripalem", "Z. Uppalapadu",
    ],
  };

  const openVideo = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
  };

  const closeVideo = () => {
    setShowModal(false);
    setSelectedVideo("");
  };

  const handleSearch = () => {
    if (!selectedVillage) {
      alert("Please select a Village");
      return;
    }

    const result = beneficiaryDetails.filter(
      (item) => item.village.toLowerCase() === selectedVillage.toLowerCase(),
    );

    setFilteredData(result);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSelectedMandal("");
    setSelectedVillage("");
    setFilteredData(null);
    setCurrentPage(1);
  };

  const beneficiaryDetails = [
    {
      imgSrc: cmrf1,
      videoSrc: video1,
      name: "Vallam Reddy Ramanamma Garu",
      relation: "W/O Brahma Reddy",
      amount: "₹3,06,500/-",
      village: "Gudluru",
      date: "2026-04-15",
      mandal: "Gudluru",
    },
    {
      imgSrc: cmrf2,
      videoSrc: video2,
      name: "Abburi Pullaya",
      relation: "S/O Abburi Venkata Rao",
      amount: "₹10,00,000/-",
      village: "Kalavalla",
      date: "2026-02-11",
      mandal: "Kandukur",
    },
    {
      imgSrc: cmrf3,
      videoSrc: video3,
      name: "Srinivas",
      relation: "S/O Srinivas",
      amount: "₹58,000/-",
      village: "Kandukur",
      date: "2025-11-5",
      mandal: "Gudluru",
    },
    {
      imgSrc: cmrf4,
      videoSrc: video4,
      name: "Srinivas",
      relation: "S/O Komali",
      amount: "₹1,38,000/-",
      village: "Kandukur",
      date: "2025-08-12",
      mandal: "Ulavapadu",
    },
    {
      imgSrc: cmrf5,
      videoSrc: video5,
      name: "Knaparthi Narayanamma",
      relation: "W/O Srinivas",
      amount: "₹28,500/-",
      village: "Muthyalapadu",
      date: "2024-05-2",
      mandal: "Lingasamudram",
    },
    {
      imgSrc: cmrf6,
      videoSrc: video6,
      name: "Venkateswarlu",
      relation: "S/O Venkateswarlu",
      amount: "₹1,07,000/-",
      village: "Gudluru",
      date: "2023-11-16",
      mandal: "Gudluru",
    },
    {
      imgSrc: cmrf7,
      videoSrc: video7,
      name: "Adhi Narayana",
      relation: "S/O Abburi Venkata Rao",
      amount: "₹1,18,000/-",
      village: "Sakhavaram",
      date: "2023-08-8",
      mandal: "Voletivaripalem",
    },
    {
      imgSrc: cmrf8,
      videoSrc: video8,
      name: "Neelisetty Nagendraaamma",
      relation: "W/O Neelisetty Venkata Rao",
      amount: "₹8,00,000/-",
      village: "Takkellapadu",
      date: "2023-03-9",
      mandal: "Gudluru",
    },
  ];

  const baseData = filteredData === null ? beneficiaryDetails : filteredData;

  // Sort data
  const sortedData = [...baseData].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return sortOrder === "latest" ? dateB - dateA : dateA - dateB;
  });

  // Pagination calculations
  const totalItems = sortedData.length;
  const totalPages = Math.ceil(totalItems / CARDS_PER_PAGE) || 1;

  // Clamp currentPage if it ever exceeds totalPages (e.g. after filtering)
  const safePage = Math.min(currentPage, totalPages);

  const startIndex = (safePage - 1) * CARDS_PER_PAGE;
  const endIndex = startIndex + CARDS_PER_PAGE;
  const displayData = sortedData.slice(startIndex, endIndex);

  // Reset to page 1 whenever sort changes
  useEffect(() => {
    setCurrentPage(1);
  }, [sortOrder]);

  // ✅ FIX: use functional updates so we always work off the latest state,
  // never a stale "currentPage" captured in a closure.
  const goToFirstPage = () => setCurrentPage(1);

  const goToPrevPage = () => {
    setCurrentPage((prev) => Math.max(1, prev - 1));
  };

  const goToNextPage = () => {
    setCurrentPage((prev) => Math.min(totalPages, prev + 1));
  };

  const goToLastPage = () => setCurrentPage(totalPages);

  const goToPage = (page) => {
    setCurrentPage(() => {
      if (page < 1) return 1;
      if (page > totalPages) return totalPages;
      return page;
    });
  };

  // Build page numbers with ellipsis (shows first, last, current +-1)
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 3;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    pages.push(1);

    let start = Math.max(2, safePage - 1);
    let end = Math.min(totalPages - 1, safePage + 1);

    if (start > 2) pages.push("...");

    for (let i = start; i <= end; i++) pages.push(i);

    if (end < totalPages - 1) pages.push("...");

    pages.push(totalPages);

    return pages;
  };

  return (
    <div className="main-container-cmrf">
      <div className="container py-2">
        <h2 className="cmrf-heading ">CMRF Beneficiary Details</h2>

        {/* <h4 className="cmrf-subhed">
          Beyond politics, eligibility is standard till now 1313 people in
          Kandukuru constituency. 11 +crores CMRF funds have been provided.
        </h4> */}
        {/* Stats Cards */}
        <div className="row mb-4 cmrf-stats-row">
          <div className="col-6 col-md-3 mb-3">
            <div className="cmrf-stat-card">
              <div className="cmrf-stat-icon cmrf-stat-icon-blue">
                <FaUsers />
              </div>
              <div>
                <p className="cmrf-stat-label">Total Beneficiaries</p>
                <h3 className="cmrf-stat-value cmrf-stat-blue">1,313</h3>
                <p className="cmrf-stat-sub">Across all villages</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3 mb-3">
            <div className="cmrf-stat-card">
              <div className="cmrf-stat-icon cmrf-stat-icon-green">
                <FaMoneyBillWave />
              </div>
              <div>
                <p className="cmrf-stat-label">Total Amount Disbursed</p>
                <h3 className="cmrf-stat-value cmrf-stat-green">
                  ₹11,00,00,000+
                </h3>
                <p className="cmrf-stat-sub">CMRF funds provided</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3 mb-3">
            <div className="cmrf-stat-card">
              <div className="cmrf-stat-icon cmrf-stat-icon-purple">
                <FaFileAlt />
              </div>
              <div>
                <p className="cmrf-stat-label">Applications Received</p>
                <h3 className="cmrf-stat-value cmrf-stat-purple">1,584</h3>
                <p className="cmrf-stat-sub">Total applications received</p>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3 mb-3">
            <div className="cmrf-stat-card">
              <div className="cmrf-stat-icon cmrf-stat-icon-orange">
                <FaCheckCircle />
              </div>
              <div>
                <p className="cmrf-stat-label">Approved Applications</p>
                <h3 className="cmrf-stat-value cmrf-stat-orange">1,313</h3>
                <p className="cmrf-stat-sub">Successfully approved</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-md-4 mb-2">
            <select
              className="form-select"
              value={selectedMandal}
              onChange={(e) => {
                setSelectedMandal(e.target.value);
                setSelectedVillage("");
              }}
            >
              <option value="">Choose Mandal</option>

              {Object.keys(mandalVillages).map((mandal) => (
                <option key={mandal} value={mandal}>
                  {mandal}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4 mb-2">
            <select
              className="form-select"
              value={selectedVillage}
              onChange={(e) => setSelectedVillage(e.target.value)}
            >
              <option value="">Choose Village</option>

              {selectedMandal &&
                mandalVillages[selectedMandal].map((village) => (
                  <option key={village} value={village}>
                    {village}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-md-4 mb-2 d-flex gap-2">
            <button className="btn btn-primary w-100" onClick={handleSearch}>
              Search
            </button>

            <button className="btn btn-secondary w-100" onClick={handleReset}>
              Show All
            </button>
          </div>
        </div>

        

        {/* Beneficiary List header with sort */}
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h4 className="mb-0 fw-bold">Beneficiary List</h4>

          <div className="d-flex align-items-center gap-2">
            <span>Sort by:</span>
            <select
              className="form-select cmrf-sort-select"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="latest">Latest First</option>
              <option value="oldest">Oldest First</option>
            </select>
          </div>
        </div>

        <div className="row">
          {displayData && displayData.length > 0 ? (
            displayData.map((beneficiary, index) => (
              <div key={index} className="col-lg-6 col-md-6 col-12 mb-4">
                <div className="card cmrf-card h-100">
                  <div className="row g-0 align-items-center h-100">
                    {/* Image Section */}
                    <div className="col-md-4">
                      <div
                        className="cmrf-img-wrapper"
                        onClick={() => openVideo(beneficiary.videoSrc)}
                      >
                        <img
                          src={beneficiary.imgSrc}
                          alt={beneficiary.name}
                          className="cmrf-img"
                        />

                        <div className="play-icon-overlay">
                          <IoPlayCircle />
                        </div>
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="col-md-8">
                      <div className="cmrf-content">
                        <h5 className="cmrf-name">{beneficiary.name}</h5>

                        <p>
                          <strong>Relation :</strong> {beneficiary.relation}
                        </p>

                        <div className="beneficiary-details">
                          <div className="detail-row">
                            <p>
                              <strong>Amount :</strong>
                              <span className="cmrf-amount">
                                {beneficiary.amount}
                              </span>
                            </p>

                            <p>
                              <strong>Date :</strong> {beneficiary.date}
                            </p>
                          </div>

                          <div className="detail-row">
                            <p>
                              <FaMapMarkerAlt className="me-1" />
                              <strong>Village :</strong> {beneficiary.village}
                            </p>

                            <p>
                              <FaBuilding className="me-1" />
                              <strong>Mandal :</strong> {beneficiary.mandal}
                            </p>
                          </div>
                        </div>

                        <button className="btn btn-outline-primary btn-sm cmrf-view-btn">
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <h2 className="text-danger fw-bold">No Data Found</h2>
            </div>
          )}
        </div>

        {/* Results text + Pagination */}
        {totalItems > 0 && (
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-3 mb-4">
            <p className="mb-0 cmrf-results-text">
              Showing {startIndex + 1} to{" "}
              {Math.min(endIndex, totalItems)} of {totalItems} results
            </p>

            <div className="d-flex align-items-center gap-1 cmrf-pagination">
              <button
                className="cmrf-page-btn"
                onClick={goToFirstPage}
                disabled={safePage === 1}
                title="First page"
              >
                «
              </button>

              <button
                className="cmrf-page-btn"
                onClick={goToPrevPage}
                disabled={safePage === 1}
                title="Previous page"
              >
                ‹
              </button>

              {getPageNumbers().map((page, i) =>
                page === "..." ? (
                  <span key={`dots-${i}`} className="cmrf-page-dots">
                    ...
                  </span>
                ) : (
                  <button
                    key={page}
                    className={`cmrf-page-btn ${
                      safePage === page ? "cmrf-page-active" : ""
                    }`}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                ),
              )}

              <button
                className="cmrf-page-btn"
                onClick={goToNextPage}
                disabled={safePage === totalPages}
                title="Next page"
              >
                ›
              </button>

              <button
                className="cmrf-page-btn"
                onClick={goToLastPage}
                disabled={safePage === totalPages}
                title="Last page"
              >
                »
              </button>
            </div>
          </div>
        )}

        {showModal && (
          <div className="video-modal-overlay" onClick={closeVideo}>
            <div
              className="video-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="video-close-btn" onClick={closeVideo}>
                ✕
              </button>

              <video controls autoPlay playsInline width="100%">
                <source src={selectedVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cmrf;